import { useNotification } from '@dsi/react-eds';
import React from 'react';
import { useContext } from 'react';

type NotificationType = {
  new: boolean;
  viewed: boolean;
  title: string;
  description: string;
  timestamp: Date;
};

interface UserContextType {
  getNotifications: () => NotificationType[];
  getNewNotificationCount: () => number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addNotifications: (notifications: any) => void;
  acknowledgeNotification: () => void;
  readNotification: () => void;
}

const NotificationsContext = React.createContext<UserContextType>({
  getNotifications: () => [],
  getNewNotificationCount: () => 0,
  addNotifications: () => {},
  acknowledgeNotification: () => {},
  readNotification: () => {}
});

// eslint-disable-next-line react-refresh/only-export-components
export const useSwobNotifications = () => {
  return useContext(NotificationsContext);
};

// Add muteNotifications prop to the provider
interface NotificationsProviderProps {
  children: React.ReactNode;
  muteNotifications?: boolean;
}

export const NotificationsProvider = ({ children, muteNotifications = false }: NotificationsProviderProps) => {
  const { getNotifications, getNewNotificationCount, addNotifications, acknowledgeNotification, readNotification } = useNotification(
    [],
    undefined,
    muteNotifications
  );

  return (
    <NotificationsContext.Provider
      value={{
        getNotifications,
        getNewNotificationCount,
        addNotifications,
        acknowledgeNotification,
        readNotification
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};
